import React from "react";
import { Grid } from "@material-ui/core";

const SingleColumnContainer = ({ children, ...props }) => (
    <Grid item xs={12} style={{ margin: "0.5em 1.5em" }} {...props}>
        {children}
    </Grid>
);

export default SingleColumnContainer;
